import _ from 'lodash';

// returns true when some of the actions are loading
const createLoadingSelector = actions => state => _(actions)
  .some(action => _.get(state, `api.loading.${action}`));
export default createLoadingSelector;
